import { api } from "./api";

export const listParents = async (params: unknown): Promise<any> => {
  const { data } = await api.get("/parent", { params });
  return data;
};

export const getParentById = async (id: any): Promise<any> => {
  const { data } = await api.get("/parent/" + id);
  return data;
};

export const parentRegister = async (body: unknown): Promise<any> => {
  const { data } = await api.post("/parent/register", body);
  return data;
};

export const updateParent = async (body: unknown): Promise<any> => {
  const { data } = await api.put("/parent/update", body);
  return data;
};

export const deleteParent = async (body: unknown): Promise<any> => {
  const { data } = await api.put("/parent/delete/", body);
  return data;
};

export const parentsPaymentType = async (body: any): Promise<any> => {
  const { data } = await api.put("/parent/payment-type", body);
  return data;
};

export const resendParentRegisterLink = async (id: any): Promise<any> => {
  const { data } = await api.post("/parent/resend/" + id);
  return data;
};
